import { UserModalLayout } from '@features/components/UserModalLayout';
import { PropsWithChildren } from 'react';
import { CustomerModalContent } from './CustomerModalContent';
import { AssignedUserData } from '@/api/apis/case';

type CustomerModalProps = {
  user: AssignedUserData;
  hospitalName?: string;
  hospitalLabel?: string;
  customerId?: string;
  txCenterId?: string;
};

export const CustomerModal = ({
  user,
  hospitalName,
  hospitalLabel,
  customerId,
  txCenterId,
  children,
}: CustomerModalProps & PropsWithChildren) => {
  return (
    <UserModalLayout trigger={children}>
      <CustomerModalContent
        user={user}
        hospitalName={hospitalName}
        hospitalLabel={hospitalLabel}
        txCenterId={txCenterId}
        customerId={customerId}
      />
    </UserModalLayout>
  );
};
